import http from "../http";


const PermissionsService = {
    GetPermissionsService: async () => {
        const Permissions = await http.instance.get("/");
        return Permissions.data
    }
};
export default PermissionsService;
